export const Logo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Horizon Advisors logo">
    <rect width="36" height="36" rx="4" fill="#1E3A5F" />
    <path d="M8 24H28" stroke="#B85D2A" strokeWidth="2" strokeLinecap="round" />
    <path d="M13 10V24" stroke="#FBF9F5" strokeWidth="2" strokeLinecap="round" />
    <path d="M23 14V24" stroke="#FBF9F5" strokeWidth="2" strokeLinecap="round" />
    <path d="M13 17H23" stroke="#FBF9F5" strokeWidth="2" />
    <circle cx="23" cy="9" r="2" fill="#B85D2A" />
  </svg>
);
